import Vue from 'vue';
import Vuex from 'vuex';

import loggedUser from './loggedUser';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    loggedUser
  },
});
